import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { BetSlipProvider } from "./context/BetSlipContext";
import { ThemeProvider } from "./context/ThemeContext";
import Home from "./Pages/Home";
import Register from "./Pages/Register";
import Casino from "./Pages/Casino";
import { ProtectedRouteLogin } from "./components/ProctectedRoute";
import Index from "./Pages/Velkie/Index";
import Detail from "./Pages/Velkie/MatchDetail/Detail";
import LeagueVelki from "./Pages/Velkie/LeagueVelki";
import SkyIndex from "./Pages/Sky/Index";
import InPlay from "./Pages/Sky/InPlay";
import DetailSky from "./Pages/Sky/MatchDetail/DetailSky";
import FavouriteVelkie from "./Pages/Velkie/FavouriteVelkie";
import FavouriteSky from "./Pages/Sky/FavouriteSky";
import SportsNew from "./Pages/Sky/SportsNew";
import AccountSky from "./Pages/Sky/AccountSky";
import AccountWeb from "./Pages/Sky/Account/AccountWeb";
import MyBetsWeb from "./Pages/Sky/Account/MyBetsWeb";
import Activitylog from "./Pages/Sky/Account/Activitylog";
import AccountStatement from "./Pages/Sky/Account/AccountStatement";
import BalanceOverview from "./Pages/Sky/Account/BalanceOverview";
import CurrentBet from "./Pages/Velkie/Account/CurrentBet";
import HomeSkyWeb from "./Pages/Sky/WebSky/Home";
import DetailWebSky from "./Pages/Sky/WebSky/Detail";
import Inplay from "./Pages/Sky/WebSky/Inplay";
import FavouriteSkyWeb from "./Pages/Sky/WebSky/FavouriteSky";

import { isMobile } from "react-device-detect";
import ActivityLog from "./Pages/Velkie/Account/ActivityLog";
import ResultSky from "./Pages/Sky/ResultSky";
import BettingHistoryVelkie from "./Pages/Velkie/Account/BettingHistoryVelkie";
import Deposit from "./Pages/Deposit";
import Withdraw from "./Pages/Withdraw";
import Promotion from "./Pages/Promotion";
import ChangePassword from "./Pages/Account/ChangePassword";
import ProfileAccount from "./Pages/Account/Profile";
import Refrel from "./Pages/Refrel";
import TransactionRecord from "./Pages/Account/TransactionRecord";
import Turnover from "./Pages/Account/Turnover";
import BettingHistroy from "./Pages/Account/BettingHistroy";
import AccountStatementProfile from "./Pages/Account/AccountStatementProfile"
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <ThemeProvider>
          <AuthProvider>
            <BetSlipProvider>
              <Outlet />
            </BetSlipProvider>
          </AuthProvider>
        </ThemeProvider>
      }
    >
      <Route path="/" element={<Home />} />{" "}
      <Route path="/register" element={<Register />} />{" "}
      <Route path="/casino" element={<Casino />} />
      <Route
        path="/deposit"
        element={
          <ProtectedRouteLogin>
            <Deposit />
          </ProtectedRouteLogin>
        }
      />
        <Route
        path="/deposit/:offerCode"
        element={
     
            <ProtectedRouteLogin>
              <Deposit />
            </ProtectedRouteLogin>
   
        }
      />
      <Route
        path="/withdraw"
        element={
          <ProtectedRouteLogin>
            <Withdraw />
          </ProtectedRouteLogin>
        }
      />
      <Route path="/promotion" element={<Promotion />} />{" "}
      <Route
        path="/profile/personal-info"
        element={
          <ProtectedRouteLogin>
            <ProfileAccount />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/history/transaction"
        element={
          <ProtectedRouteLogin>
            <TransactionRecord />
          </ProtectedRouteLogin>
        }
      />
    <Route
        path="/history/betting"
        element={
          <ProtectedRouteLogin>
            <BettingHistroy />
          </ProtectedRouteLogin>
        }
      />

      
     <Route
        path="/history/turnover"
        element={
          <ProtectedRouteLogin>
            <Turnover />
          </ProtectedRouteLogin>
        }
      />

    
          <Route
        path="/history/account-statement"
        element={
          <ProtectedRouteLogin>
            <AccountStatementProfile />
          </ProtectedRouteLogin>
        }
      />
      
      <Route path="/referral" element={<Refrel />} />
      <Route
        path="/profile/change-password"
        element={
          <ProtectedRouteLogin>
            <ChangePassword />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/profile"
        element={
          <ProtectedRouteLogin>
            <AccountWeb />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/my-bets"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/profit-loss"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/activity-log"
        element={
          <ProtectedRouteLogin>
            <Activitylog />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/account-statement"
        element={
          <ProtectedRouteLogin>
            <AccountStatement />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/balance-overview"
        element={
          <ProtectedRouteLogin>
            <BalanceOverview />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/menu/active-log"
        element={
          <ProtectedRouteLogin>
            <ActivityLog />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/menu/current-bet"
        element={
          <ProtectedRouteLogin>
            <CurrentBet />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/menu/bet-history"
        element={
          <ProtectedRouteLogin>
            <BettingHistoryVelkie />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/result-sky"
        element={
          <ProtectedRouteLogin>
            <ResultSky />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-velki"
        element={
          <ProtectedRouteLogin>
            <Index />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/sports-sky/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-sky-new"
        element={
          <ProtectedRouteLogin>
            <SportsNew />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/account-sky"
        element={
          <ProtectedRouteLogin>
            <AccountSky />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/favourite-velkie"
        element={
          <ProtectedRouteLogin>
            <FavouriteVelkie />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/favourite-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <FavouriteSky /> : <FavouriteSkyWeb />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/inplay-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <InPlay /> : <Inplay />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/league-velki"
        element={
          <ProtectedRouteLogin>
            <LeagueVelki />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-sky/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-sky/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
    </Route>,
  ),
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
